import { render } from "./SkillItem.vue?vue&type=template&id=aa69e17c"
import script from "./SkillItem.vue?vue&type=script&lang=js"
export * from "./SkillItem.vue?vue&type=script&lang=js"
script.render = render

export default script